import { Component, OnInit, ChangeDetectionStrategy, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OnboardingService } from '../../shared/service/onboarding.service';
import { OnboardEducationDetails } from '../../shared/models/OnboardEducationDetails';
import { FormControl, FormGroup, AbstractControl, FormBuilder, FormArray } from '@angular/forms';
import { OnboardPreviousEmploymentDetails } from '../../shared/models/OnboardPreviousEmploymentDetails';
import { OnboardProfessionalReferenceDetails } from '../../shared/models/OnboardProfessionalReferenceDetails';
import { MatDialog } from '@angular/material';
import { ConfirmDialogComponent, ConfirmDialogModel } from '../../shared/components/confirm-dialog/confirm-dialog.component';
import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
import { OnboardEmployeeDetails } from '../../shared/models/OnboardEmployeeDetails';
import { OnboardEmployeePersonalDetails } from '../../shared/models/OnboardEmployeePersonalDetails';
import { OnboardEmployeePassportVisaInfo } from '../../shared/models/OnboardEmployeePassportVisaInfo';
import { OnboardEmployeeFinanceDetails } from '../../shared/models/OnboardEmployeeFinanceDetails';
import { AppConfig } from '../../app.config';
import { PreviousEmploymentComponent } from '../previous-employment/previous-employment.component';
import { BasicEmpDetailsComponent } from '../basic-emp-details/basic-emp-details.component';
import { PersonalDetailsComponent } from '../personal-details/personal-details.component';
import { EducationDetailsComponent } from '../education-details/education-details.component';
import { ReferenceDetailsComponent } from '../reference-details/reference-details.component';
import { PassportvisaInformationComponent } from '../passportvisa-information/passportvisa-information.component';
import { FinanceDetailsComponent } from '../finance-details/finance-details.component';
import { ComponentIdentificationService } from '../../shared/service/component-identification.service';
import { OnboardEmployee } from '../../shared/models/OnboardEmployee';
import { isNullOrUndefined } from 'util';
import { OnboardEmpEducationInformation } from '../../shared/models/OnboardEmpEducationInformation';
import { OnboardPrevEmploymentInfo } from '../../shared/models/OnboardPrevEmploymentInfo';

@Component({
  selector: 'app-onboarding',
  templateUrl: './add-employee-details.component.html',
  styleUrls: ['./add-employee-details.component.css']
})

export class AddEmployeeDetailsComponent implements OnInit {
  @ViewChild(BasicEmpDetailsComponent, { static: false }) basicEmpDetComponent: BasicEmpDetailsComponent;
  @ViewChild(PersonalDetailsComponent, { static: false }) personalDetailsComponent: PersonalDetailsComponent;
  @ViewChild(EducationDetailsComponent, { static: false }) educationDetailsComponent: EducationDetailsComponent;
  @ViewChild(PreviousEmploymentComponent, { static: false }) previousEmploymentComponent: PreviousEmploymentComponent;
  @ViewChild(ReferenceDetailsComponent, { static: false }) referenceDetailsComponent: ReferenceDetailsComponent;
  @ViewChild(PassportvisaInformationComponent, { static: false }) passportvisaInformationComponent: PassportvisaInformationComponent;
  @ViewChild(FinanceDetailsComponent, { static: false }) financeDetailsComponent: FinanceDetailsComponent;
  MAX_SIZE: number = 1048576;
  slug: any;
  error: string;
  selectedIndex: number;
  MaritalStatus: any;
  newAttribute: any = {};
  selected = new FormControl(0);
  rows: FormArray = this.fb.array([]);
  prevEmp: FormArray = this.fb.array([]);
  visaArray: FormArray = this.fb.array([]);
  passportArray: FormArray = this.fb.array([]);
  Children: FormArray = this.fb.array([]);
  prevEmploymentDetails: OnboardPrevEmploymentInfo;
  referenceDetails: OnboardProfessionalReferenceDetails[] = [];
  result: any;
  employeeDetails: OnboardEmployeeDetails;
  personalDetails: OnboardEmployeePersonalDetails;
  educationDetails: OnboardEducationDetails[] = [];
  passportVisaDetails: OnboardEmployeePassportVisaInfo;
  FinanceDetails: OnboardEmployeeFinanceDetails;
  OnboardEmployeeDetails: OnboardEmployee;
  educationInfo: OnboardEmpEducationInformation;
  additionalQualifications: any[];
  EmpId: number;
  datePipe: DatePipe;
  Status: number;
  constructor(private route: ActivatedRoute, private router: Router, private config: AppConfig, private _service: OnboardingService, public dialog: MatDialog, private toastr: ToastrService, private fb: FormBuilder, private changeCom_svc: ComponentIdentificationService) { }
  ngOnInit() {
    //get the slug from url
    this.route.params.subscribe(params => {
      this.slug = params['slug'];
      //status 1 indicates the employee still need to submit the details
      this.Status = 1;
    });
    //Assign the parent component name to recognize the parent in child component
    this.changeCom_svc.changeComponentName("app-onboarding");
    this.selectedIndex = 0;
    this.OnboardEmployeeDetails = new OnboardEmployee();
    this.employeeDetails = new OnboardEmployeeDetails();
    this.personalDetails = new OnboardEmployeePersonalDetails();
    this.passportVisaDetails = new OnboardEmployeePassportVisaInfo();
    this.FinanceDetails = new OnboardEmployeeFinanceDetails();
    this.educationInfo = new OnboardEmpEducationInformation();
    this.prevEmploymentDetails = new OnboardPrevEmploymentInfo();
  }

  submit() {
    if (this.basicEmpDetComponent.EmpDetform.invalid || this.educationDetailsComponent.EducationDetailForm.invalid) {
      this.toastr.warning("Please fill the required fields");
      return;
    }
    const message = `After submission you cannot edit further. Do you want to continue?`;
    var deleteType = "Submit";
    const dialogData = new ConfirmDialogModel(" ", message, deleteType);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "400px",
      data: dialogData
    });
    dialogRef.afterClosed().subscribe(dialogResult => {
      // console.log(dialogResult);
      if (dialogResult) {
        //here parameter 2 is passed in status to mark the employee has submitted the details
        this._service.submitDetails(this.EmpId, 2).subscribe((data: any) => {
          this.router.navigateByUrl("/submission");
        },
          error => this.error = error);
      }
    }, error => { this.result = error; });
    return this.result;
  }

  //To make the mat-tab move to next tab
  changeTab() { this.selected.setValue(this.selected.value + 1); }

  //To make the mat-tab move to previous tab
  BackTab() { this.selected.setValue(this.selected.value - 1); }

  //To clear the form data in each tab by switch condition
  ResetData(value) {
    switch (value) {
      case 'basicEmployeeDetails': this.basicEmpDetComponent.EmpDetform.reset();
        this.basicEmpDetComponent.getEmployeebySlugStatus();
        this.personalDetailsComponent.PersonalDetform.reset();
        this.Children.clear();
        this.personalDetailsComponent.GetEmployeePersonalDetails();
        this.financeDetailsComponent.FinanceForm.reset();
        this.financeDetailsComponent.GetOnboardEmpolyeeFinanceDetails();
        break;
      case 'EducationDetails': this.educationDetailsComponent.rows = this.fb.array([]);
        this.educationDetailsComponent.getData();
        this.passportvisaInformationComponent.passportArray = this.fb.array([]);
        this.passportvisaInformationComponent.visaArray = this.fb.array([]);
        this.passportvisaInformationComponent.GetPassportVisaInfo(); break;
      case 'ReferenceDetails': this.previousEmploymentComponent.prevEmp = this.fb.array([]);
        this.previousEmploymentComponent.GetOnboardPrevEmploymentDetails();
        this.previousEmploymentComponent.GetOnboardEmpReferences(); break;
    }
  }

  //Read the output values from child components
  getEmpId(val) { this.EmpId = val; }
  getEmployeeDtlsOutput(val) { this.employeeDetails = val; }
  getEducationDtlsOutput(val) { this.rows = val; }
  getPersonalDtlsOutput(val) { this.personalDetails = val; }
  getPrevEmploymentDtlsOutput(val) { this.prevEmp = val; }
  getReferenceDtlsOutput(val) { this.referenceDetails = val; }
  getPassportVisaDtlsOutput(val) { this.passportArray = val; }
  getVisaDtlsOutput(val) { this.visaArray = val; }
  getFinanceDtlsOutput(val) { this.FinanceDetails = val; }
  getChildrenArrayOutput(val) { this.Children = val; }
  getAdditionalQualificationsOutput(val) { this.additionalQualifications = val; }

  //SaveEducationDetails(val) {
  //  this.datePipe = new DatePipe('en-US');
  //  for (var i = 0; i < this.rows.value.length; i++) {
  //    this.rows.value[i].EmpId = this.EmpId;
  //    this.rows.value[i].YearOfPassing = new Date(this.datePipe.transform(this.rows.value[i].YearOfPassing, this.config.dateFormat()));
  //  }
  //  console.log(this.rows.value);
  //  this._service.saveEducationDetails(this.rows.value).subscribe((data: any) => {
  //    if (data.ErrorType == "Exception") {
  //      this.toastr.warning(data.ErrorMsg);
  //    }
  //    else {
  //      this.toastr.success("Saved Successfully");
  //      if (val) { this.changeTab(); }
  //    }
  //  },
  //    error => this.error = error);
  //}
  //SavePrevEmploymentDetails(value) {
  //  console.log(this.prevEmp.value);
  //  this.datePipe = new DatePipe('en-US');
  //  for (var i = 0; i < this.prevEmp.value.length; i++) {
  //    this.prevEmp.value[i].OnboardEmployeeId = this.EmpId;
  //    this.prevEmp.value[i].FromDate = new Date(this.datePipe.transform(this.prevEmp.value[i].FromDate, this.config.dateFormat()));
  //    this.prevEmp.value[i].ToDate = new Date(this.datePipe.transform(this.prevEmp.value[i].ToDate, this.config.dateFormat()));
  //  }
  //  this._service.SavePrevEmploymentDetails(this.prevEmp.value).subscribe((data: any) => {
  //    if (data.ErrorType == "Exception") {
  //      this.toastr.warning(data.ErrorMsg);
  //    }
  //    else {
  //      this.toastr.success("Saved Successfully");
  //      if (value) { this.changeTab(); }
  //    }
  //  },
  //    error => this.error = error);
  //}
  //SavereferenceDetails(value) {
  //  for (var i = 0; i < this.referenceDetails.length; i++) {
  //    this.referenceDetails[i].EmpId = this.EmpId;
  //  }
  //  this._service.SaveReferenceDetails(this.referenceDetails).subscribe((data: any) => {
  //    if (data.ErrorType == "Exception") {
  //      this.toastr.warning(data.ErrorMsg);
  //    }
  //    else {
  //      this.toastr.success("Saved Successfully");
  //      if (value) { this.changeTab(); }
  //    }
  //  },
  //    error => this.error = error);
  //}
  //SaveEmployeeDetails(value) {
  //  if (!this.basicEmpDetComponent.EmpDetform.invalid) {
  //    this.datePipe = new DatePipe('en-US');
  //    this.employeeDetails.DOB = new Date(this.datePipe.transform(this.employeeDetails.DOB, this.config.dateFormat()));
  //    this.employeeDetails.CelebratedDOB = new Date(this.datePipe.transform(this.employeeDetails.CelebratedDOB, this.config.dateFormat()));
  //    this._service.saveEmpDetails(this.employeeDetails).subscribe((data: any) => {
  //      this.toastr.success("Saved Successfully");
  //      if (value) {
  //        this.changeTab();
  //      }
  //    }, error => this.toastr.warning(error));
  //  }

  //}
  SavePersonalEmpDetails() {
    this.datePipe = new DatePipe('en-US');
    this.personalDetails.EmpId = this.EmpId;
    this.personalDetails.ModifiedBy = this.EmpId.toString();
    if (this.personalDetailsComponent.PersonalDetform.invalid) {
      this.toastr.warning("Please fill the required fields");
      return;
    } else if (this.personalDetails.emergencyContactDtls.length < 1) {
      this.toastr.warning("Please fill the emergency contact details");
      return;
    }
    for (var i = 0; i < this.personalDetails.emergencyContactDtls.length; i++) {
      let element = this.personalDetails.emergencyContactDtls[i];
      if ((isNullOrUndefined(element.ContactPersonName) || this.isEmptyOrSpaces(element.ContactPersonName)) &&
        isNullOrUndefined(element.ContactPhoneNumber) && isNullOrUndefined(element.RelationId)
      ) {
        this.toastr.warning("Please fill the emergency contact details");
        return;
      }
      if (this.personalDetails.emergencyContactDtls[i].ContactPersonName != null) {
        if (this.personalDetails.emergencyContactDtls[i].ContactPhoneNumber == null || isNullOrUndefined(this.personalDetails.emergencyContactDtls[i].RelationId)) {
          this.toastr.warning("Please fill the remaining fields in emergency contact details");
          return;
        }
      }
      else {
        if (this.personalDetails.emergencyContactDtls[i].ContactPhoneNumber != null || !isNullOrUndefined(this.personalDetails.emergencyContactDtls[i].RelationId)) {
          this.toastr.warning("Please enter the name");
          return;
        }
      }
      this.personalDetails.emergencyContactDtls[i].EmpId = this.EmpId;
      this.personalDetails.emergencyContactDtls[i].ModifiedBy = this.EmpId.toString();
    }
    //Assigned father,mother,spouse and children details are moved to array of FamilyDetails
    this.personalDetails.FamilyDetails = [];
    this.personalDetails.Father.RelationId = 1; // RelationId 1 indicates father
    this.personalDetails.FamilyDetails[0] = this.personalDetails.Father;
    this.personalDetails.Mother.RelationId = 2; // RelationId 2 indicates mother
    this.personalDetails.FamilyDetails[1] = this.personalDetails.Mother;
    if (this.personalDetails.MaritalStatus == 1) {  //MaritalStatus 1 indicates Married
      //If wedding date has value then changes the date format
      if (!isNullOrUndefined(this.personalDetails.WeddingDate))
        this.personalDetails.WeddingDate = new Date(this.datePipe.transform(this.personalDetails.WeddingDate, this.config.dateFormat()));
      this.personalDetails.Spouse.RelationId = 3; // RelationId 3 indicates spouse
      this.personalDetails.FamilyDetails[2] = this.personalDetails.Spouse;
      var j = 3;
      for (var i = 0; i < this.Children.value.length; i++) {
        this.personalDetails.FamilyDetails[j] = this.Children.value[i];
        j += 1;
      }
    }
    for (var i = 0; i < this.personalDetails.FamilyDetails.length; i++) {
      this.personalDetails.FamilyDetails[i].EmpID = this.EmpId;
      this.personalDetails.FamilyDetails[i].ModifiedBy = this.EmpId.toString();
      if (!isNullOrUndefined(this.personalDetails.FamilyDetails[i].DOB))
        this.personalDetails.FamilyDetails[i].DOB = new Date(this.datePipe.transform(this.personalDetails.FamilyDetails[i].DOB, this.config.dateFormat()));
    }
    this.personalDetails.onboardVrifications = null;
    this.OnboardEmployeeDetails.personalDetails = this.personalDetails;
    //this._service.SavePersonalEmpDetails(this.personalDetails).subscribe((data: any) => {
    //  if (data.ErrorType == "Exception") {
    //    this.toastr.warning(data.ErrorMsg);
    //  }
    //  else {
    //    this.toastr.success("Saved Successfully");
    //    if (value) {
    //      this.changeTab();
    //    }
    //  }
    //}, error => this.toastr.warning(error));
  }
  //SavePassportVisaDetails(value) {
  //  this.datePipe = new DatePipe('en-US');
  //  this.passportVisaDetails.PassportIssueDate = new Date(this.datePipe.transform(this.passportVisaDetails.PassportIssueDate, this.config.dateFormat()));
  //  this.passportVisaDetails.PassportExpiryDate = new Date(this.datePipe.transform(this.passportVisaDetails.PassportExpiryDate, this.config.dateFormat()));
  //  if (this.visaArray.value.length != 0) {
  //    for (var i = 0; i < this.visaArray.value.length; i++) {
  //      this.visaArray.value[i].EmpId = this.EmpId;
  //      this.visaArray.value[i].ExpiryDate = new Date(this.datePipe.transform(this.visaArray.value[i].ExpiryDate, this.config.dateFormat()));
  //    }
  //  }
  //  this.passportVisaDetails.onboardVisas = this.visaArray.value;
  //  console.log(this.passportVisaDetails.onboardVisas);
  //  this._service.SavePassportVisaDetails(this.passportVisaDetails).subscribe((data: any) => {
  //    if (data.ErrorType == "Exception") {
  //      this.toastr.warning(data.ErrorMsg);
  //    }
  //    else {
  //      this.toastr.success("Saved Successfully");
  //      if (value) {
  //        this.changeTab();
  //      }
  //    }
  //  }, error => this.toastr.warning(error));
  //}
  //SaveFinanceDetails(value) {
  //  this._service.SaveFinanceDetails(this.FinanceDetails).subscribe((data: any) => {
  //    this.toastr.success("Saved Successfully");
  //    if (value) {
  //      this.changeTab();
  //    }
  //  }, error => this.toastr.warning(error));
  //}
  SaveOnboardEmployeeDetails(value) {
    this.datePipe = new DatePipe('en-US');
    if (!this.basicEmpDetComponent.EmpDetform.invalid) {
      if (!isNullOrUndefined(this.basicEmpDetComponent.EmpDetform.get('DOB').value)) {
        this.employeeDetails.DOB = new Date(this.datePipe.transform(this.employeeDetails.DOB, this.config.dateFormat()));
      }
      if (!isNullOrUndefined(this.basicEmpDetComponent.EmpDetform.get('CelebratedDOB').value)) {
        this.employeeDetails.CelebratedDOB = new Date(this.datePipe.transform(this.employeeDetails.CelebratedDOB, this.config.dateFormat()));
      }
      this.employeeDetails.ModifiedBy = this.EmpId.toString();
      this.OnboardEmployeeDetails.employeeDetails = this.employeeDetails;
    }
    else {
      this.toastr.warning("Please fill the required fields");
      return;
    }
    this.SavePersonalEmpDetails();
    this.FinanceDetails.onboardVrifications = null;
    this.FinanceDetails.ModifiedBy = this.EmpId.toString();
    this.OnboardEmployeeDetails.financeDetails = this.FinanceDetails;
    this._service.SaveOnboardEmployeeDetails(this.OnboardEmployeeDetails).subscribe((data: any) => {
      this.basicEmpDetComponent.getEmployeebySlugStatus();
      this.financeDetailsComponent.GetOnboardEmpolyeeFinanceDetails();
      this.toastr.success("Saved Successfully");
      if (value) {
        this.changeTab();
      }
    }, error => this.toastr.warning(error));
  }

  SaveEducationInformation(value) {
    this.datePipe = new DatePipe('en-US');
    if (!this.educationDetailsComponent.EducationDetailForm.invalid) {
      this.educationDetailsComponent.assignDocumentsListToObject();
      for (var i = 0; i < this.rows.value.length; i++) {
        this.rows.value[i].EmpId = this.EmpId;
        this.rows.value[i].ModifiedBy = this.EmpId.toString();
        //check whether any documents are attached to each qualification
        if (isNullOrUndefined(this.rows.value[i].OnboardHREmpDocs) || this.rows.value[i].OnboardHREmpDocs.length < 1) {
          this.toastr.warning("One attachment is mandatory for your qualification: " + this.rows.value[i].Qualification);
          return;
        }
      }
      this.educationInfo.educationDetails = this.rows.value;
    }
    else {
      this.toastr.warning("Please fill the required fields");
      return;
    }
    //Check whether employee contains additional qualifications
    if (this.additionalQualifications != null && this.additionalQualifications.length != 0) {
      var count = 0;
      this.educationInfo.AdditionalQualifications = [];
      for (var i = 0; i < this.additionalQualifications.length; i++) {
        if (!isNullOrUndefined(this.additionalQualifications[i].Name)) {
          if (!this.isEmptyOrSpaces(this.additionalQualifications[i].Name) && isNullOrUndefined(this.additionalQualifications[i].additionalDocs)) {
            this.toastr.warning("Document is mandatory for your additional qualification");
            return;
          }
        }
        // if name field is empty and doc is attached ,name should also be entered
        else if (isNullOrUndefined(this.additionalQualifications[i].Name)) {
          if (!isNullOrUndefined(this.additionalQualifications[i].additionalDocs)) {
            this.toastr.warning("Please provide the Name of the Qualification/Certification");
            return;
          }
        }
        //assign additional qualifications data to the education info object
        if (!isNullOrUndefined(this.additionalQualifications[i].additionalDocs)) {
          for (var j = 0; j < this.additionalQualifications[i].additionalDocs.length; j++) {
            this.educationInfo.AdditionalQualifications = this.educationInfo.AdditionalQualifications.concat(this.additionalQualifications[i].additionalDocs[j]);
            this.educationInfo.AdditionalQualifications[count].EmpId = this.EmpId;
            this.educationInfo.AdditionalQualifications[count].ModifiedBy = this.EmpId.toString();
            this.educationInfo.AdditionalQualifications[count].DocTypeName = this.additionalQualifications[i].Name;
            count++;
          }
        }
      }
    }
    if (this.passportArray.value.length != 0) {
      for (var i = 0; i < this.passportArray.value.length; i++) {
        this.passportArray.value[i].EmpId = this.EmpId;
        this.passportArray.value[i].ModifiedBy = this.EmpId.toString();
        if (!isNullOrUndefined(this.passportArray.value[i].IssueDate)) {
          this.passportArray.value[i].IssueDate = new Date(this.datePipe.transform(this.passportArray.value[i].IssueDate, this.config.dateFormat()));
        }
        if (!isNullOrUndefined(this.passportArray.value[i].ExpiryDate)) {
          this.passportArray.value[i].ExpiryDate = new Date(this.datePipe.transform(this.passportArray.value[i].ExpiryDate, this.config.dateFormat()));
        }
        if (!isNullOrUndefined(this.passportArray.value[i].File)) {
          if (isNullOrUndefined(this.passportArray.value[i].DocNumber) || isNullOrUndefined(this.passportArray.value[i].IssueDate) || isNullOrUndefined(this.passportArray.value[i].ExpiryDate) || isNullOrUndefined(this.passportArray.value[i].Country) || this.passportArray.value[i].Country == "") {
            this.toastr.warning("Please fill the details to save the passport file");
            return;
          }
        }
        else if (!isNullOrUndefined(this.passportArray.value[i].DocNumber)) {
          if (isNullOrUndefined(this.passportArray.value[i].IssueDate) || isNullOrUndefined(this.passportArray.value[i].ExpiryDate) || this.passportArray.value[i].Country == "") {
            this.toastr.warning("Please fill the remaining details for your passport information");
            return;
          }
        }
      }
    }
    if (this.visaArray.value.length != 0) {
      for (var i = 0; i < this.visaArray.value.length; i++) {
        this.visaArray.value[i].EmpId = this.EmpId;
        this.visaArray.value[i].ModifiedBy = this.EmpId.toString();
        if (!isNullOrUndefined(this.visaArray.value[i].ExpiryDate)) {
          this.visaArray.value[i].ExpiryDate = new Date(this.datePipe.transform(this.visaArray.value[i].ExpiryDate, this.config.dateFormat()));
        }
        if ((!isNullOrUndefined(this.visaArray.value[i].File) && this.visaArray.value[i].File != "")) {
          if (this.visaArray.value[i].Country === "" || this.visaArray.value[i].DocType === "" || isNullOrUndefined(this.visaArray.value[i].ExpiryDate)) {
            this.toastr.warning("Please fill the details to save the visa file");
            return;
          }
        }
        else if ((this.visaArray.value[i].Country != "")) {
          if (this.visaArray.value[i].DocType === "" || isNullOrUndefined(this.visaArray.value[i].ExpiryDate)) {
            this.toastr.warning("Please fill the remaining details for your visa information");
            return;
          }
        }
        else if ((this.visaArray.value[i].DocType != "")) {
          if (this.visaArray.value[i].Country === "" || isNullOrUndefined(this.visaArray.value[i].ExpiryDate)) {
            this.toastr.warning("Please fill the remaining details for your visa information");
            return;
          }
        }
        else if (!isNullOrUndefined(this.visaArray.value[i].ExpiryDate)) {
          if (this.visaArray.value[i].DocType === "" || this.visaArray.value[i].Country === "") {
            this.toastr.warning("Please fill the remaining details for your visa information");
            return;
          }
        }
        if (this.visaArray.value[i].ExpiryDate && this.visaArray.value[i].DocType != "" && this.visaArray.value[i].Country != ""
          && (isNullOrUndefined(this.visaArray.value[i].File) || this.visaArray.value[i].File === "")) {
          if (isNullOrUndefined(this.visaArray.value[i].DocumentPath)) {
            this.toastr.warning("Please attach the visa file");
            return;
          }
        }
      }
    }
    this.passportVisaDetails.onboardVrifications = null;
    this.passportVisaDetails.onboardVisas = this.visaArray.value;
    this.passportVisaDetails.onboardPassport = this.passportArray.value;
    this.educationInfo.passportVisaDetails = this.passportVisaDetails;
      this._service.SaveOnboardEducationInfo(this.educationInfo).subscribe((data: any) => {
        this.educationDetailsComponent.getData();
        this.passportvisaInformationComponent.GetPassportVisaInfo();
        if (data.ErrorType == "Exception") {
          this.toastr.warning(data.ErrorMsg);
        }
        else {
          this.toastr.success("Saved Successfully");
          if (value) { this.changeTab(); }
        }
      },
        error => this.error = error);
    }
  //returns true if given string is empty or had spaces
  isEmptyOrSpaces(str) {
    return str === null || str.match(/^ *$/) !== null;
  }
  SavePreviousEmploymentDetails(value) {
    this.datePipe = new DatePipe('en-US');
    this.previousEmploymentComponent.assignDocumentsListToObject();
    for (var i = 0; i < this.prevEmp.value.length; i++) {
      this.prevEmp.value[i].EmpId = this.EmpId;
      this.prevEmp.value[i].ModifiedBy = this.EmpId.toString();
      if (!isNullOrUndefined(this.prevEmp.value[i].FromDate)) {
        this.prevEmp.value[i].FromDate = new Date(this.datePipe.transform(this.prevEmp.value[i].FromDate, this.config.dateFormat()));
      }
      if (!isNullOrUndefined(this.prevEmp.value[i].ToDate)) {
        this.prevEmp.value[i].ToDate = new Date(this.datePipe.transform(this.prevEmp.value[i].ToDate, this.config.dateFormat()));
      }
      //condition to check whether the below fields has value
      if (!this.isEmptyOrSpaces(this.prevEmp.value[i].CompanyName)) {
        if (this.isEmptyOrSpaces(this.prevEmp.value[i].Designation) && this.isEmptyOrSpaces(this.prevEmp.value[i].JobLocation) ||
          isNullOrUndefined(this.prevEmp.value[i].ToDate) && isNullOrUndefined(this.prevEmp.value[i].FromDate)) {
          this.toastr.warning("Please fill the remaining fields for" + this.prevEmp.value[i].CompanyName);
          return;
        }
        //if any field has value then attachment of document is mandatory
        if (isNullOrUndefined(this.prevEmp.value[i].OnboardHREmpDocs) || this.prevEmp.value[i].OnboardHREmpDocs.length < 1) {
          this.toastr.warning("One attachment is mandatory for your experience in " + this.prevEmp.value[i].CompanyName);
          return;
        }
      }
    }
    for (var i = 0; i < this.referenceDetails.length; i++) {
      this.referenceDetails[i].EmpId = this.EmpId;
      this.referenceDetails[i].ModifiedBy = this.EmpId.toString();
      if (!isNullOrUndefined(this.referenceDetails[i].Company) || !isNullOrUndefined(this.prevEmp.value[i].CompanyName)) {
        if (!isNullOrUndefined(this.referenceDetails[i].Company)) {
          if (this.referenceDetails[i].Company != "") {
            if ((isNullOrUndefined(this.referenceDetails[i].ContactPersonName) || isNullOrUndefined(this.referenceDetails[i].ContactPhoneNumber)) || isNullOrUndefined(this.referenceDetails[i].ContactInfo)) {
              this.toastr.warning("Please fill the remaining fields for " + this.referenceDetails[i].Company);
              return;
            }
          }
          else {
            this.toastr.warning("Please enter Company name as " + this.prevEmp.value[i].CompanyName);
            return;
          }
        }
        else {
          this.toastr.warning("One reference details is required for your experience in " + this.prevEmp.value[i].CompanyName);
          return;
        }
      }
    }
    this.prevEmploymentDetails.OnboardPrevEmploymentDetails = this.prevEmp.value;
    this.prevEmploymentDetails.OnboardProfessionalRefDetails = this.referenceDetails;
    this._service.SaveOnboardPreviousEmploymentInfo(this.prevEmploymentDetails).subscribe((data: any) => {
      this.previousEmploymentComponent.GetOnboardPrevEmploymentDetails();
      this.previousEmploymentComponent.GetOnboardEmpReferences();
        this.toastr.success("Saved Successfully");
        if (value) { this.changeTab(); }
    },
      error => this.error = error);
  }
}
